import _ from 'lodash';

export default class UrlUtils {

  /**
   * Different params that can be handled by our apps
   */
  static params = {
    CALLBACK_URI: 'callbackUri',
    ACCESS_TOKEN: 'accessToken',
    CLIENT_ID: 'clientId',
  }

  /**
   * Used to notify an event when redirect to the callback_uri
   */
  static callbackEvents = {
    NO_PREVIOUS_PAGE: 'NO_PREVIOUS_PAGE',
    INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
    NEW_ORDER: 'NEW_ORDER',
  }

  static getPrettyUrl(url: string): string {
    if (_.isEmpty(url)) {
      return '';
    }
    if (url.indexOf('https://') === 0) {
      return url.slice('https://'.length);
    }
    if (url.indexOf('http://') === 0) {
      return url.slice('http://'.length);
    }
    return url;
  }

  static getDomainUrl(url: string): string {
    if (_.isEmpty(url)) {
      return '';
    }
    let domain = '';

    // find & remove protocol (http, ftp, etc.) and get domain
    if (url.indexOf('://') > -1) {
      domain = url.split('/')[2];
    } else {
      domain = url.split('/')[0];
    }

    // find & remove port number
    domain = domain.split(':')[0];

    return domain;
  }

  /**
   * Add `https://` on the given url if not exists.
   */
  static toValidUrl(url: string): string {
    if (url.indexOf('://') === -1) {
      return `https://${url}`;
    }

    return url;
  }

  static getQueryParam(name, url = window.location.href): string {
    name = name.replace(/[\[\]]/g, '\\$&')

    const regex = new RegExp("[?&]" + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
    if (!results) {
      return null
    }
    if (!results[2]) {
      return ''
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  static formatCallbackUri(callbackUri, event) {
    return callbackUri.indexOf('?') === -1 ? `${callbackUri}?event=${event}` : `${callbackUri}&event=${event}`
  }
}
